import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import "./List.css";
import { GetAllFarmerSignDataFromSeedDestribution } from "./Common";
import { FaEdit, FaSearch } from "react-icons/fa";
import { FILE_BASE_URL } from "./Constatnt";

const SignatureThumbList = () => {
  const navigate = useNavigate();
  const { orgCode, year, seasonId } = useParams();

  const [fetchedUserId, setFetchedUserId] = useState("");
  const [data, setData] = useState([]);
  const [search, setSearch] = useState("");
  const [searchInput, setSearchInput] = useState(""); // separate input state
  const [previewImageUrl, setPreviewImageUrl] = useState(null);
  const [showImagePopup, setShowImagePopup] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [pagination, setPagination] = useState({
    currentPage: 1,
    pageSize: 50,
    totalRecords: 0,
    totalPages: 1,
  });

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleNavigate = () => {
    navigate(`/`);
  };

const handleViewImage = (url) => {
  if (!url || url.trim() === "") {
    alert("No image available.");
    return;
  }
  const fullUrl = `${FILE_BASE_URL}${url}`;
  
  // Check if the image actually loads
  const img = new Image();
  img.onload = () => {
    setPreviewImageUrl(fullUrl);
    setShowImagePopup(true);
  };
  img.onerror = () => {
    alert("Image Not Found.");
  };
  img.src = fullUrl;
};




  const fetchData = async () => {
    const { currentPage, pageSize } = pagination;
    const payload = {
      Org_Code: orgCode,
      page: currentPage,
      limit: pageSize,
      sortBy: "Mobile_Number",
      sortOrder: "ASC",
      search,
      Year: year,
      Season_ID: seasonId,
    };

    try {
      const response = await GetAllFarmerSignDataFromSeedDestribution(payload);
      const responseData = response?.data?.data || [];
      const pageInfo = response?.data?.pagination;
      setData(responseData);
      setFetchedUserId(responseData[0]?.User_ID || "");

      if (pageInfo) {
        setPagination((prev) => ({
          ...prev,
          totalRecords: Number(pageInfo.totalRecords) || responseData.length,
          totalPages: Number(pageInfo.totalPages) || 1,
        }));
      } else {
        const totalRecords = responseData.length;
        setPagination((prev) => ({
          ...prev,
          totalRecords,
          totalPages: Math.ceil(totalRecords / pageSize) || 1,
        }));
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setData([]);
    }
  };

  useEffect(() => {
    fetchData();
  }, [pagination.currentPage, pagination.pageSize, search, orgCode]);

  // Handle typing in search box
  const handleSearchInputChange = (e) => {
    setSearchInput(e.target.value);
  };

  // Trigger search
  const triggerSearch = () => {
    setSearch(searchInput);
    setPagination((prev) => ({ ...prev, currentPage: 1 }));
  };

  // Trigger search on Enter
  const handleSearchKeyDown = (e) => {
    if (e.key === "Enter") {
      triggerSearch();
    }
  };

  const handlePageSizeChange = (e) => {
    const newSize = parseInt(e.target.value, 10) || 10;
    setPagination((prev) => ({ ...prev, pageSize: newSize, currentPage: 1 }));
  };

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= pagination.totalPages) {
      setPagination((prev) => ({ ...prev, currentPage: newPage }));
    }
  };

  const { currentPage, pageSize, totalRecords, totalPages } = pagination;

  const handleEdit = (userId) => {
    if (orgCode && userId) {
      navigate(`/signature-thumb/${orgCode}/${userId}`);
    } else {
      console.error("Missing orgCode or userId for edit navigation");
    }
  };

  return (
    <div className="page">
      <div className="inner-page-wrapper">
        <section className="division wide-30">
          <div className="container">
            <div
              className="header"
              style={{
                position: "relative",
                textAlign: "center",
                marginBottom: "20px",
              }}
            >
              <h2 style={{ margin: 0 }}>Signature List</h2>
              <button onClick={handleNavigate} className="back-button">
                ← Back
              </button>
            </div>

            <div className="card">
              <div className="card-body">
                <div className="controls">
                  <div className="show-select">
                    <label>Show</label>
                    <select value={pageSize} onChange={handlePageSizeChange}>
                      {[50, 100, 250, 500].map((num) => (
                        <option key={num} value={num}>
                          {num}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div
                    className="search-box"
                    style={{
                      position: "relative",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <input
                      type="search"
                      placeholder="Search..."
                      value={searchInput}
                      onChange={handleSearchInputChange}
                      onKeyDown={handleSearchKeyDown}
                      style={{ paddingRight: "30px" }}
                    />
                    <FaSearch
                      onClick={triggerSearch}
                      style={{
                        position: "absolute",
                        right: "8px",
                        cursor: "pointer",
                        color: "#555",
                      }}
                    />
                  </div>
                </div>

                <div className="table-wrapper">
                  <table className="custom-table">
                    <thead>
                      <tr>
                        <th>ID</th>
                        <th>Tracenet Code</th>
                        <th>Name</th>
                        <th> Farmer Thumb</th>
                        <th> Farmer Sign</th>
                        <th> Field Map</th>
                        <th>Approval Manager Sign</th>
                        <th>Internal Inspector Sign</th>
                        <th> Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {data.length === 0 ? (
                        <tr>
                          <td colSpan="11" className="text-center">
                            No records found
                          </td>
                        </tr>
                      ) : (
                        data.map((item, index) => {
                          return (
                            <tr key={item.Seed_Distribution_ID}>
                              <td>
                                {(currentPage - 1) * pageSize + index + 1}
                              </td>
                              <td>{item?.Mobile_Number || "N/A"}</td>
                              <td>{item?.User_Name || "N/A"}</td>
                              <td>
                                {item?.Seed_Distributions?.[0]
                                  ?.Signature_Thumb ? (
                                  <button
                                    onClick={() =>
                                      handleViewImage(
                                        item?.Seed_Distributions?.[0]
                                          ?.Signature_Thumb
                                      )
                                    }
                                    className="text-blue-600 hover:underline text-sm font-semibold"
                                  >
                                    View Fingerprint
                                  </button>
                                ) : (
                                  "N/A"
                                )}
                              </td>
                              <td>
                                {item?.Seed_Distributions?.[0]?.Signature_Pad ? (
                                  <button
                                    onClick={() =>
                                      handleViewImage(
                                        item?.Seed_Distributions?.[0]
                                          .Signature_Pad
                                      )
                                    }
                                    className="text-blue-600 hover:underline text-sm font-semibold"
                                  >
                                    View Signature
                                  </button>
                                ) : (
                                  "N/A"
                                )}
                              </td>
                              <td>
                                {item?.FieldMapImages?.[0]
                                  ?.Field_Map_Image ? (
                                  <button
                                    onClick={() =>
                                      handleViewImage(
                                       item?.FieldMapImages?.[0]
                                  ?.Field_Map_Image
                                      )
                                    }
                                    className="text-blue-600 hover:underline text-sm font-semibold"
                                  >
                                    View Feild Map
                                  </button>
                                ) : (
                                  "N/A"
                                )}
                              </td>
                              <td>
                                {item?.Seed_Distributions?.[0]
                                  ?.Sign_Approvel_Meneger ? (
                                  <button
                                    onClick={() =>
                                      handleViewImage(
                                        item?.Seed_Distributions?.[0]
                                          ?.Sign_Approvel_Meneger
                                      )
                                    }
                                    className="text-blue-600 hover:underline text-sm font-semibold"
                                  >
                                    View Approval Manage Sign
                                  </button>
                                ) : (
                                  "N/A"
                                )}
                              </td>
                              <td>
                                {item?.Seed_Distributions?.[0]
                                  ?.Sign_Internal_Inspectore ? (
                                  <button
                                    onClick={() =>
                                      handleViewImage(
                                        item?.Seed_Distributions?.[0]
                                          ?.Sign_Internal_Inspectore
                                      )
                                    }
                                    className="text-blue-600 hover:underline text-sm font-semibold"
                                  >
                                    View Internal Inspector Sign
                                  </button>
                                ) : (
                                  "N/A"
                                )}
                              </td>
                              <td>
                                <button
                                  onClick={() => handleEdit(item?.User_ID)}
                                  className="text-blue-500 hover:text-blue-700"
                                >
                                  <FaEdit size={18} />
                                </button>
                              </td>
                            </tr>
                          );
                        })
                      )}
                    </tbody>
                  </table>
                </div>

                <div className="pagination-container">
                  <div>
                    Showing{" "}
                    {totalRecords === 0 ? 0 : (currentPage - 1) * pageSize + 1}{" "}
                    to {Math.min(currentPage * pageSize, totalRecords)} of{" "}
                    {totalRecords} entries
                  </div>
                  <div className="pagination-buttons">
                    <button
                      disabled={currentPage === 1}
                      onClick={() => handlePageChange(currentPage - 1)}
                    >
                      Previous
                    </button>
                    {Array.from({ length: totalPages }, (_, i) => i + 1).map(
                      (page) => (
                        <button
                          key={page}
                          className={page === currentPage ? "active" : ""}
                          onClick={() => handlePageChange(page)}
                        >
                          {page}
                        </button>
                      )
                    )}
                    <button
                      disabled={currentPage === totalPages}
                      onClick={() => handlePageChange(currentPage + 1)}
                    >
                      Next
                    </button>
                  </div>
                </div>

               {showImagePopup && previewImageUrl && (
  <div
    style={{
      position: "fixed",
      top: 0,
      left: 0,
      width: "100vw",
      height: "100vh",
      backgroundColor: "rgba(0, 0, 0, 0.6)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 9999,
    }}
    onClick={() => {
      setShowImagePopup(false);
      setPreviewImageUrl(null);
    }}
  >
    <img
      src={previewImageUrl}
      alt="Preview"
      style={{
        maxWidth: "90%",
        maxHeight: "90%",
        background: "#fff",
        padding: "10px",
        borderRadius: "8px",
      }}
    />
  </div>
)}

              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default SignatureThumbList;
